import { DataTable } from '@uhg-abyss/web/ui/DataTable';
import { useDataTable } from '@uhg-abyss/web/hooks/useDataTable';
import { Box } from '@uhg-abyss/web/ui/Box';
import { mapV1ColumnsToV2, withRowIds } from '@src/utils/tableUtils';
import { HEADER_THEME_CSS } from '@src/common/Table';

import React, { useEffect } from 'react';

export const GPSDetailViewTable = ({ detailViewList }) => {
  const CellContainer = ({ value, highlight }) => {
    return <Box color={highlight ? '#e6e600' : ''}>{value}</Box>;
  };
  const columns = React.useMemo(() => {
    return [
      {
        Header: 'Field Name',
        accessor: 'fieldName',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        width: 300,
        label: 'Field Name',
        Cell: ({ row }) => (
          <CellContainer
            value={row?.original?.fieldName}
            highlight={row?.original?.isHighlight}
          />
        ),
      },

      {
        Header: 'Data Prior To Processing',
        accessor: 'dataBeforeProcessing',
        width: 300,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        label: 'Data Prior To Processing',
        Cell: ({ row }) => (
          <CellContainer
            value={row?.original?.dataBeforeProcessing}
            highlight={row?.original?.isHighlight}
          />
        ),
      },
      {
        Header: 'Incoming Customer Data',
        accessor: 'incomingCustomerData',
        canToggleVisibilty: true,
        width: 300,
        isHiddenByDefault: false,
        label: 'Incoming Customer Data',
        Cell: ({ row }) => (
          <CellContainer
            value={row?.original?.incomingCustomerData}
            highlight={row?.original?.isHighlight}
          />
        ),
      },

      {
        Header: 'Data After Processing',
        accessor: 'dataAfterProcessing',
        canToggleVisibilty: true,
        width: 300,
        isHiddenByDefault: false,
        label: 'Data After Processing',
        Cell: ({ row }) => (
          <CellContainer
            value={row?.original?.dataAfterProcessing}
            highlight={row?.original?.isHighlight}
          />
        ),
      },
    ];
  }, []);

  const v2Columns = React.useMemo(() => mapV1ColumnsToV2(columns), [columns]);

  const dataTableProps = useDataTable<any>({
    initialData: [] as any[],
    initialColumns: v2Columns,
    rowIdKey: 'uniqueId',
    paginationConfig: { enablePagination: false },
  });

  useEffect(() => {
    if (v2Columns?.length) {
      dataTableProps.setColumns(v2Columns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [v2Columns]);
  function camelCaseToTitleCase(camelCase) {
    if (!camelCase) return '';
    const result = camelCase?.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
  function maskSSN(ssn) {
    return String(ssn);
  }
  useEffect(() => {
    if (detailViewList) {
      let arr: any[] = [];
      arr = [...arr, detailViewList];

      const modifiedArr: any[] = [];
      const keys = Object.keys(arr[0]?.dataAfterProcessing);
      const valuesAfter = Object.values(arr[0]?.dataAfterProcessing) as any[];
      const valuesBefore = Object.values(
        arr[0]?.dataPriorToProcessing
      ) as any[];
      const incomingCustomerData = Object.values(
        arr[0]?.incomingCustomerData
      ) as any[];

      for (let num = 0; num < keys.length; num++) {
        if (
          keys[num] != 'address' &&
          keys[num] != 'coverages' &&
          keys[num] != 'policyamnt' &&
          keys[num] != 'docssup' &&
          keys[num] != 'authresp' &&
          keys[num] != 'broker' &&
          keys[num] != 'sponsor' &&
          keys[num] != 'gpsMemberAddressList' &&
          keys[num] != 'gpsMemberContactList'
        ) {
          var datAftProcValue;
          var datBefProcValue;
          var incomCustData;
          if (
            camelCaseToTitleCase(keys[num]).includes('Social Security Number')
          ) {
            datAftProcValue =
              maskSSN(valuesAfter[num]) !== 'undefined'
                ? maskSSN(valuesAfter[num])
                : '';
            datBefProcValue =
              maskSSN(valuesBefore[num]) !== 'undefined'
                ? maskSSN(valuesBefore[num])
                : '';
            incomCustData =
              maskSSN(incomingCustomerData[num]) !== 'undefined'
                ? maskSSN(incomingCustomerData[num])
                : '';
          } else {
            datAftProcValue = valuesAfter[num];
            datBefProcValue = valuesBefore[num];
            incomCustData = incomingCustomerData[num];
          }
          modifiedArr.push({
            fieldName: camelCaseToTitleCase(keys[num]),
            dataAfterProcessing: datAftProcValue,
            dataBeforeProcessing: datBefProcValue,
            incomingCustomerData: incomCustData,
            isHighlight: !!(
              (
                (datAftProcValue?.length > 0 && // Check if datAftProcValue has a length greater than 0
                  datBefProcValue?.length > 0 && // Check if datBefProcValue has a length greater than 0
                  datAftProcValue?.trim().toLowerCase() !== // Check if trimmed and lowercased datAftProcValue is not equal to
                    datBefProcValue?.trim().toLowerCase()) || // trimmed and lowercased datBefProcValue
                ((datBefProcValue == null ||
                  datBefProcValue.trim().length === 0) && // Check if datBefProcValue is null or empty
                  datAftProcValue != null &&
                  datAftProcValue.trim().length > 0)
              ) // Check if datAftProcValue is not null and has a length greater than 0
            ),
          });
        } else if (keys[num] == 'address') {
          const addressArrayAfter = valuesAfter[num];
          const addressArrayBefore = valuesBefore[num];
          const addressArrayIncoming = incomingCustomerData[num];
          for (let i = 0; i < addressArrayAfter?.length; i++) {
            const addressKeys = Object.keys(addressArrayAfter[i]);
            const addressValuesAfter =
              addressArrayAfter && addressArrayAfter[i]
                ? Object?.values(addressArrayAfter[i])
                : null;
            const addressValuesBefore =
              addressArrayBefore && addressArrayBefore[i]
                ? Object?.values(addressArrayBefore[i])
                : null;
            const addressValuesIncoming =
              addressArrayIncoming && addressArrayIncoming[i]
                ? Object?.values(addressArrayIncoming[i])
                : null;

            for (let j = 0; j < addressKeys?.length; j++) {
              modifiedArr.push({
                fieldName: camelCaseToTitleCase(addressKeys[j]),
                dataAfterProcessing: addressValuesAfter
                  ? (addressValuesAfter[j] as string)
                  : null,

                dataBeforeProcessing: addressValuesBefore
                  ? (addressValuesBefore[j] as string)
                  : null,
                incomingCustomerData: addressValuesIncoming
                  ? (addressValuesIncoming[j] as string)
                  : null,
                isHighlight: !!(
                  (
                    (addressValuesAfter != null && // Check if addressValuesAfter is not null
                      addressValuesBefore != null && // Check if addressValuesBefore is not null
                      (addressValuesAfter as string[])[j]?.length > 0 && // Check if the j-th element of addressValuesAfter has a length greater than 0
                      (addressValuesBefore as string[])[j]?.length > 0 && // Check if the j-th element of addressValuesBefore has a length greater than 0
                      (addressValuesAfter as string[])[j]
                        ?.trim()
                        .toLowerCase() !== // Check if the trimmed and lowercased j-th element of addressValuesAfter is not equal to
                        (addressValuesBefore as string[])[j]
                          ?.trim()
                          .toLowerCase()) || // the trimmed and lowercased j-th element of addressValuesBefore
                    ((addressValuesBefore == null ||
                      (addressValuesBefore as string[])[j]?.trim().length ===
                        0) && // Check if addressValuesBefore is null or empty
                      (addressValuesAfter as string[])[j]?.length > 0)
                  ) // Check if the j-th element of addressValuesAfter has a length greater than 0
                ),
              });
            }
          }
        } else if (
          keys[num] == 'coverages' ||
          keys[num] == 'policyamnt' ||
          keys[num] == 'docssup' ||
          keys[num] == 'authresp' ||
          keys[num] == 'sponsor' ||
          keys[num] == 'broker' ||
          keys[num] == 'gpsMemberAddressList' ||
          keys[num] == 'gpsMemberContactList'
        ) {
          const subArrayAfter = valuesAfter[num];
          const subArrayBefore = valuesBefore[num];
          const subArrayIncoming = incomingCustomerData[num];
          for (let i = 0; i < subArrayAfter?.length; i++) {
            const subKeys = Object.keys(subArrayAfter[i]);
            const subValueAfter =
              subArrayAfter && subArrayAfter[i]
                ? Object?.values(subArrayAfter[i])
                : null;
            const subValueBefore =
              subArrayBefore && subArrayBefore[i]
                ? Object.values(subArrayBefore[i])
                : null;

            const subValuesIncoming =
              subArrayIncoming && subArrayIncoming[i]
                ? Object?.values(subArrayIncoming[i])
                : null;

            for (let j = 0; j < subKeys?.length; j++) {
              let fieldName = camelCaseToTitleCase(subKeys[j]);
              let dataAfterProcessing = subValueAfter
                ? (subValueAfter as string[])[j]
                : null;
              let dataBeforeProcessing = subValueBefore
                ? (subValueBefore as string[])[j]
                : null;
              let incomingCustomerData = subValuesIncoming
                ? (subValuesIncoming as string[])[j]
                : null;

              // Check if the key is 'id' and set the field name accordingly
              if (subKeys[j] === 'id') {
                continue;
              }

              modifiedArr.push({
                fieldName: fieldName, // Sets the fieldName property
                dataAfterProcessing: dataAfterProcessing, // Sets the dataAfterProcessing property
                dataBeforeProcessing: dataBeforeProcessing, // Sets the dataBeforeProcessing property
                incomingCustomerData: incomingCustomerData, // Sets the incomingCustomerData property
                isHighlight:
                  !!(
                    (
                      (dataBeforeProcessing == null ||
                        dataBeforeProcessing.trim().length === 0) && // Checks if dataBeforeProcessing is null or empty
                      dataAfterProcessing != null && // Checks if dataAfterProcessing is not null
                      dataAfterProcessing.trim().length > 0
                    ) // Checks if dataAfterProcessing has a length greater than 0
                  ) ||
                  (dataAfterProcessing != null && // Checks if dataAfterProcessing is not null
                    dataBeforeProcessing != null && // Checks if dataBeforeProcessing is not null
                    dataAfterProcessing.trim().toLowerCase() !== // Checks if trimmed and lowercased dataAfterProcessing is not equal to
                      dataBeforeProcessing.trim().toLowerCase()), // trimmed and lowercased dataBeforeProcessing
              });
            }
          }
        }
      }

      dataTableProps.setData(withRowIds(modifiedArr));
    }
  }, [detailViewList]);

  return (
    <DataTable
      title=""
      hideHeader
      tableState={dataTableProps}
      css={{
        width: '100%',
        '.abyss-data-table-cell': { padding: 0 },
        ...HEADER_THEME_CSS,
      }}
    >
      <DataTable.Table />
    </DataTable>
  );
};
